import React, {useEffect, useState} from 'react';
import { useLocation, Link as RouterLink } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { Grid, Container, Typography, Box } from '@mui/material';
import { Update, Unauthorized } from '../sections/@dashboard/manageUser';
import { useUserProfileDataQuery } from '../services/dvagent';
import { getToken, getAdmin } from '../services/LocalStorageService';
import { UserProfileCard } from '../components/skeleton';
import { Toaster } from '../sections/@dashboard/attributes';

export default function UserUpdate() {

  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState({});
  const [userAccess, setUserAccess] = useState([]);
  const { data, isSuccess, error } = useUserProfileDataQuery({ "email": location.state, "token": getToken(), "location":location });
  const [toasterData, setToasterData] = useState({
    trigger: false,
    status: true,
    symbol: '✔',
    message: '',
  });

  useEffect(() => {
    if (error) {
      if (error.status === 401) {
        // showToast(false, 'ⓘ', 'Unauthorized User');
      } else {
        showToast(false, 'ⓘ', 'Something went wrong, server error');
      }
    }
    if (data && isSuccess) {
      setUser(data.data[0]);
      setUserAccess(data.userAccess);
    }
    setTimeout(() => {
      setLoading(true);
    }, 2000);
  }, [data, isSuccess, error]);  

  const showToast = (status, symbol, message) => {
    setToasterData({
      trigger: true,
      status,
      symbol,
      message,
    });

    setTimeout(() => {
      setToasterData((prev) => ({
        ...prev,
        trigger: false,
      }));
    }, 5000); 
  };
  return (
    <>
      <Helmet>
        <title> DV Agent </title>
      </Helmet>
      {toasterData.trigger && (
        <Toaster
          trigger={toasterData.trigger}
          status={toasterData.status}
          symbol={toasterData.symbol}
          message={toasterData.message}
        />
      )}
      <Container maxWidth="xxl">
        <Grid item xs={12}>
          <div style={{ display: 'flex', alignItems: 'center' }}>
            <Box to="/cloud/users" component={RouterLink} state={{ dropdownState: 'Users' }}>
              <img width={40} src="../../assets/back-button.gif" alt="verified" style={{ marginLeft: 4, display: 'inline-block', verticalAlign: 'middle' }} />
            </Box>
            <Typography
              gutterBottom
              variant=""
              component="div"
              sx={{
                color: '#A8A196',
                textAlign: 'left',
                marginLeft: 2,
                fontSize: '1.2rem',
                fontWeight: 'bold',
              }}
            >
              I AM
              <Typography variant="" component="div" sx={{ fontSize: 12, color: '#4D4D4D' }}>
                USER INFORMATION
              </Typography>
            </Typography>
          </div>
        </Grid>
        {loading ? (
          <Grid container spacing={2}>
            {getAdmin() === 'false' ? <Unauthorized/> : <Update user={user} access={userAccess}/> }
          </Grid>
        ):(
          <Grid container spacing={2}>
            <UserProfileCard/>
          </Grid>
        )}
      </Container>
    </>
  );
}